import {Children} from "interfaces";
import {Container} from "./styled";
import {CSSProperties} from "react";

interface AbsoluteProps extends Children, CSSProperties {}

export const Absolute: React.FC<AbsoluteProps> = ({children, ...cssStyle}) => {
  return <Container style={cssStyle}>{children}</Container>;
};
